import { useEffect, useRef } from 'react';

import useNotify from '@hooks/notify';

// Fires a single error toast on the rising edge of `hasError`
const useErrorToast = (hasError: boolean, message?: string): void => {
  const notify = useNotify();
  const wasError = useRef(false);

  useEffect(() => {
    if (hasError && !wasError.current) notify.createErrorAlert(message);
    wasError.current = hasError;
  }, [hasError, notify, message]);
};

export default useErrorToast;
